/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'monetization';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * post-/monetization/v3/request/seat
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RequestsResource+type:symbol+createSeatRequest&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Requests-post-%2Fmonetization%2Fv3%2Frequest%2Fseat'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fmonetization%2Fv3%2Frequest%2Fseat?showRequestDetails=true&body=%7B%22apiName%22:%22string%22,%22requestReason%22:%22string%22,%22requestedSeatType%22:%22string%22%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const createSeatRequestRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v3/request/seat'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/product/in-app
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ProductResource+type:symbol+getActiveProductsWithVersionsInAppLegacy&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Product-get-%2Fmonetization%2Fv3%2Fproduct%2Fin-app'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fproduct%2Fin-app?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getActiveProductsWithVersionsInAppLegacyRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/product/in-app'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/currency
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:CurrencyResource+type:symbol+getInAppCurrencyResponse&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Currency-get-%2Fmonetization%2Fv3%2Fcurrency'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fcurrency?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getCurrencyRequestRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/currency'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/seats/inventory
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:SeatsResource+type:symbol+getProductInventory&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Seats-get-%2Fmonetization%2Fv3%2Fseats%2Finventory'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fseats%2Finventory?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getProductInventoryRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/seats/inventory'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/request/seat
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RequestsResource+type:symbol+getSeatRequests&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Requests-get-%2Fmonetization%2Fv3%2Frequest%2Fseat'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Frequest%2Fseat?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getSeatRequestsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/request/seat'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/monetization/v3/purchase-motions
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:PurchaseMotionsResource+type:symbol+getInAppPurchaseMotionResponse&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Purchase_Motions-get-%2Fmonetization%2Fv3%2Fpurchase-motions'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmonetization%2Fv3%2Fpurchase-motions?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const purchaseMotionsGetRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/purchase-motions'])
});